import { Direction } from '@angular/cdk/bidi';
import { Overlay } from '@angular/cdk/overlay';
import { Component, Inject } from '@angular/core';
import { CardDesignComponent } from 'src/app/@shared/components/design/slide-up-card/card-design.component';
import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { ModalService } from 'src/app/@shared/services/modal/modal.service';
import { DATA_INJECTION_TOKEN } from 'src/app/@shared/services/overlay/overlay.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { UtilsService } from 'src/app/@shared/services/utils/utils.service';
import { QueryParamsService } from 'src/app/@shared/services/query-params/query-params.service';
import {
  ADD_TO_FAVORITES,
  LINES_CALENDAR,
  MORE_ACTIONS_MENU,
  ROUTE_PLANNING,
  REMOVE_FROM_FAVORITES,
  SHARE,
  SHOW_ON_MAP,
  STATION_DETAILS,
  STATION,
  STATION_CODE,
  PRINT,
  PRINT_ARIA_LABEL,
  SEARCH_BY_STATION,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { eSpecialMessagesEffects } from 'src/app/modules/route-planner/constants/special-messages.constants';
import { eFavoriteType } from 'src/app/modules/route-planner/enums/favorite/favorite-type.enum';
import { eTab } from 'src/app/modules/route-planner/enums/route-planning/tabs/tabs.enums';
import { FavoriteStations } from 'src/app/modules/route-planner/interfaces/favorites/favorite-stations.interface';
import { SearchStopForm } from 'src/app/modules/route-planner/interfaces/route-planning/forms/search-stop-form';
import { SpecialMessage } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/special-messages/special-message.interface';
import { Stop } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/stop.interface';
import { StopFullData } from 'src/app/modules/route-planner/interfaces/route-planning/service/@schedule-service.interface';
import { FavoritesService } from 'src/app/modules/route-planner/services/favorites/favorites.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { SearchStationDeatiledResultMapComponent } from './search-station-deatiled-result-map/search-station-deatiled-result-map.component';
import { PrintService } from 'src/app/modules/route-planner/services/print/print.service';
@Component({
    selector: 'app-search-station-detailed-result',
    templateUrl: './search-station-detailed-result.component.html',
    styleUrls: ['./search-station-detailed-result.component.scss'],
    standalone: false
})
export class SearchStationDetailedResultComponent extends CardDesignComponent {
  isFavoriteStation: boolean = false;
  isFavoriteLine: boolean = false;
  direction: Direction;

  shareText: string;
  routePlanningText: string;
  showOnMapText: string;
  linesCalendarText: string;
  stationDetailsText: string;
  moreActionsMenuText: string;
  addToFavoritesText: string;
  removeFromFavoritesText: string;
  printText: string;
  printAriaLabelText: string;
  titleText: string;

  isStationCancled: boolean;
  isStationNotActive: boolean;
  isNavigatingToStation: boolean = false

  moreActionsMenuItems: SelectOption<string>[] = [];

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay: Overlay,

    @Inject(DATA_INJECTION_TOKEN)
    public readonly data: {
      formValues: SearchStopForm;
      stop: StopFullData;
      displayOnMapOverlay: boolean;
    },

    private readonly favoritesService: FavoritesService,
    private readonly modalService: ModalService,
    private readonly languageService: LanguageService,
    private readonly utilsService: UtilsService,
    private readonly printService: PrintService,
    private readonly queryParamsService: QueryParamsService
  ) {
    super(routePlanningService, resizeService, overlay);
  }

  get isPrinting(): boolean {
    return this.printService.isPrinting;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    const stop = this.data.stop;
   

    if (stop.isCanceled) {
      this.openStationCanceledModal();
    }

    this.isStationNotActive = !stop.routesInStop?.length
    if (this.isStationNotActive) {
      this.modalService.openStationNotActiveModal();
    }

    this.isFavoriteStation =
      !!this.favoritesService.favorites?.stations?.stations?.find(
        (favoriteStation) => favoriteStation.stopcode === stop.stopcode
      );
    this.initializeMultiLanguageTexts();
    this.openMapOverlay();
  }

  handleCloseClick(closeStationsList: boolean = false, isLanguageDirectionChanged: boolean = false) {
    if (!!this.data.displayOnMapOverlay) {
      this.routePlanningService._mapOverlaySub.next(null);
    }
    this.routePlanningService._resultSubject.next({
      type: 'selected',
      value: null,
    });
    this.queryParamsService.setQueryParam('poiSelectedIndex',null)
    this.closeCard({closeStationsList, isLanguageDirectionChanged});
  }

  override handleOverlayEscape(): void {
    this.handleCloseClick(false, false);
  }

  openMapOverlay() {
    if (!!this.isDesktop && !!this.data.displayOnMapOverlay) {
      this.routePlanningService._mapOverlaySub.next({
        mapComponent: SearchStationDeatiledResultMapComponent,
        data: { stop: this.data.stop, showPickStationButton: false },
      });
    }
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      if(this.direction) {
        this.handleCloseClick(false,true);
        return;
      }
      this.direction = language.direction;
      this.shareText = SHARE[language.language];
      this.routePlanningText = ROUTE_PLANNING[language.language];
      this.showOnMapText = SHOW_ON_MAP[language.language];
      this.stationDetailsText = STATION_DETAILS[language.language];
      this.linesCalendarText = LINES_CALENDAR[language.language];
      this.printText = PRINT[language.language];
      this.printAriaLabelText = PRINT_ARIA_LABEL[language.language];
      this.moreActionsMenuText = MORE_ACTIONS_MENU[language.language];
      this.addToFavoritesText = ADD_TO_FAVORITES[language.language];
      this.removeFromFavoritesText = REMOVE_FROM_FAVORITES[language.language];
      this.titleText = SEARCH_BY_STATION[language.language];
      this.buildMoreActionsMenuItems();
    });
  }

  toggleFavoriteRoute() {
    const favoriteStations = this.favoritesService.favorites?.stations;
    const newStations = favoriteStations?.stations
      ? [...favoriteStations?.stations]
      : [];

    if (!this.isFavoriteStation) {
      newStations.push({
        ...this.data.stop,
        type: eFavoriteType.STATIONS,
      });
    } else {
      newStations.splice(
        newStations.findIndex(
          (station) => station.stopcode == this.data.stop.stopcode
        ),
        1
      );
    }

    const newFavoriteStations: FavoriteStations = {
      ...favoriteStations,
      stations: newStations,
      type: eFavoriteType.STATIONS,
    };

    this.favoritesService.updateFavorite(newFavoriteStations);
    this.isFavoriteStation = !this.isFavoriteStation;
    this.buildMoreActionsMenuItems();
  }

  private buildMoreActionsMenuItems(): void {
    this.moreActionsMenuItems = [
      {
        label: this.isFavoriteStation ? this.removeFromFavoritesText : this.addToFavoritesText,
        value: 'favorite',
        icon: this.isFavoriteStation ? 'heart-filled' : 'heart',
        ariaLabel: this.isFavoriteStation ? this.removeFromFavoritesText : this.addToFavoritesText,
        onClick: () => this.toggleFavoriteRoute(),
      },
      {
        label: this.printText,
        value: 'print',
        icon: 'print',
        ariaLabel: this.printAriaLabelText,
        onClick: () => this.handlePrint(),
      },
    ];
  }

  openShareLinkPopup() {
    // Get the current poiSelectedIndex from query params or preserve it if already there
    const currentIndex =
      this.queryParamsService.currentParams['poiSelectedIndex'];

    // If we have POI data in the form values, ensure we save it in query params
    if (this.data && this.data.formValues && this.data.formValues.poi) {
      const params: any = {
        poi: this.data.formValues.poi.name,
        tab: eTab.STATIONS,
        saveParams: true,
      };

      if (this.data.formValues.poi.lat && this.data.formValues.poi.lng) {
        params.poiLat = this.data.formValues.poi.lat;
        params.poiLng = this.data.formValues.poi.lng;
      }

      // Maintain the selected station index in the shared URL
      if (currentIndex !== undefined) {
        params.poiSelectedIndex = currentIndex;
      }

      this.queryParamsService.setQueryParams(params);
    }

    setTimeout(() => {
      const currentUrl = window.location.href;
      navigator.clipboard
        .writeText(currentUrl)
        .then(() => {
          console.debug('URL copied to clipboard:', currentUrl);
        })
        .catch((err) => {
          console.error('Could not copy URL to clipboard:', err);
        });

      this.modalService.openShareLinkModal();
    }, 300);
  }

  openStationCanceledModal() {
    this.modalService.openStationCanceledModal(this.data.stop);
  }

  handlePrint() {
    // Show loading indicator immediately - use setTimeout to allow browser to render
    this.printService.showLoadingIndicator();
    
    // Use setTimeout(0) to yield to browser rendering before continuing
    setTimeout(() => {
      const printableElement = document.getElementById('printableArea');
      if (!printableElement) {
        console.warn('No printable content found!');
        return;
      }
      const mapTab = document.querySelector(
        '[mat-tab-label*="map" i], [mat-tab-label*="מפה" i]'
      );
      if (mapTab) {
        (mapTab as HTMLElement).click();
        setTimeout(() => this.printContent(printableElement), 10);
      } else {
        this.printContent(printableElement);
      }
    }, 0);
  }

  private printContent(printableElement: HTMLElement) {
    const currentLanguage = this.languageService.getSelectedLanguage().language;

    const headerInfo = {
      title: STATION_DETAILS[currentLanguage],
      details: [
        {
          label: STATION[currentLanguage],
          value: this.data.stop.name || 'N/A',
        },
        {
          label: STATION_CODE[currentLanguage],
          value: this.data.stop.stopcode || 'N/A',
        },
      ],
    };

    const mapService = this.routePlanningService.getMapService();
    this.printService.captureAndPrint(
      printableElement,
      headerInfo as any,
      mapService,
      2
    );
  }
}
